import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=5e6e401e&"
import script from "../../services/admin/reset-password.js?vue&type=script&lang=js&"
export * from "../../services/admin/reset-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports